import React, {Component, Fragment} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
} from 'reactstrap';
import {Field, Form as FinalForm} from 'react-final-form';
import {withTranslation} from 'react-i18next';
import TextField from '../../../../components/TextField';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {NotificationManager} from '../../../../components/common/react-notifications';
import LoaderButton from '../../../../components/LoaderButton';
import Select from 'react-select';
import Api from '../../../../services/Api';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import {required} from '../../../../helpers/Validators';
import FieldError from '../../../../components/FieldError';

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rbac: null,
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/rbac');
      this.setState({
        rbac: data,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  createAdmin = async values => {
    const {t} = this.props;
    try {
      await Api.invoke('POST', '/v2/admin-ui/adminUsers', {
        ...values,
        role: values.role.value,
      });
      NotificationManager.success(t('Admin created successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  ReactSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      placeholder={this.props.t('Select')}
    />
  );

  render() {
    const {t, match} = this.props;
    const {rbac} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {t('Create Admin')}
                </CardTitle>
                <FinalForm
                  onSubmit={this.createAdmin}
                  render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
                    return (
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                            <TextField
                              item={{
                                name: 'firstName',
                                i18n: t('First Name'),
                                type: 'text',
                                required: true,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                            <TextField
                              item={{
                                name: 'lastName',
                                i18n: t('Last Name'),
                                type: 'text',
                                required: true,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                            <TextField
                              item={{
                                name: 'phoneNumber',
                                i18n: t('Mobile Number'),
                                type: 'text',
                                required: true,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                            <TextField
                              item={{
                                name: 'email',
                                i18n: t('Email'),
                                type: 'text',
                                required: true,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                            <TextField
                              item={{
                                name: 'username',
                                i18n: t('Username'),
                                type: 'text',
                                required: true,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                            <TextField
                              item={{
                                name: 'password',
                                i18n: t('Password'),
                                type: 'password',
                                required: true,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                           <span>
                             {t('Role')}
                             <span className="required">*</span>
                           </span>
                            <Field
                              name="role"
                              component={this.ReactSelectAdapter}
                              isLoading={!rbac || !rbac.roles}
                              options={rbac && rbac.roles ? rbac.roles.map(role => ({label: role, value: role})) : []}
                              validate={required}
                              closeMenuOnSelect={false}
                            />
                            <FieldError name='role' />
                          </Col>
                        </Row>
                        <LoaderButton
                          loading={submitting}
                          onClick={handleSubmit}
                          disabled={pristine || hasValidationErrors || submitting}
                          className="mt-4 text-center"
                          style={{minWidth: '100px'}}>
                          {t('Save')}
                        </LoaderButton>
                      </Form>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Create);
